"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@chakra-ui/react");

var _core = require("@react-pdf-viewer/core");

require("@react-pdf-viewer/core/lib/styles/index.css");

var _defaultLayout = require("@react-pdf-viewer/default-layout");

require("@react-pdf-viewer/default-layout/lib/styles/index.css");

require("@react-pdf-viewer/print/lib/styles/index.css");

var _jsxRuntime = require("react/jsx-runtime");
/**
* @license
*
* SPDX-FileCopyrightText: Copyright © 2021 snek.at
* SPDX-License-Identifier: EUPL-1.2
*
* Use of this source code is governed by an EUPL-1.2 license that can be found
* in the LICENSE file at https://snek.at/license
*/


var PdfViewer = function PdfViewer(_ref) {
  var src = _ref.src,
      style = _ref.style,
      onClose = _ref.onClose,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? false : _ref$overlay,
      _ref$toolbar = _ref.toolbar,
      toolbar = _ref$toolbar === void 0 ? false : _ref$toolbar;
  var defaultLayoutPluginInstance = (0, _defaultLayout.defaultLayoutPlugin)({
    toolbarPlugin: {
      printPlugin: {
        enableShortcuts: false
      },
      zoomPlugin: {
        enableShortcuts: true
      }
    }
  });
  var viewer = /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Viewer, {
    fileUrl: src,
    initialPage: 0,
    theme: "dark",
    defaultScale: _core.SpecialZoomLevel.PageWidth // set plugins if toolbar is enabled
    ,
    plugins: toolbar ? [defaultLayoutPluginInstance] : []
  });

  var handleBackdrop = function handleBackdrop(e) {
    if (e.target !== e.currentTarget) return;
    onClose();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Portal, {
    appendToParentPortal: false,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Worker, {
      workerUrl: "https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.js",
      children: overlay ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
        h: "100vh",
        w: "100%",
        top: "0",
        pos: "absolute",
        onClick: handleBackdrop,
        bg: "rgba(0,0,0,0.6)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.AbsoluteCenter, {
          h: "100vh",
          w: "50%",
          children: viewer
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
        h: "100%",
        w: "50%",
        margin: "0 auto",
        style: style,
        children: viewer
      })
    })
  });
};

var _default = PdfViewer;
exports["default"] = _default;